import React, {
  createContext,
  useContext,
  useEffect,
  useState,
} from "react";
import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";
import {
  httpClient,
} from "settings/apolloClient.jsx";

export const AUTHORIZED_OPERATOR_QUERY = gql`
  query {
    getCurrentAutomationOperator {
      id
      name
    }
  }
`;

// Selects the same fields as AUTHORIZED_OPERATOR_QUERY so the payload can be
// written straight into that query's cache entry (see OperatorSubscriber). A
// single backend poller (AutomationOperatorPoller) publishes on change, so a
// take/release of command from any source updates every screen live.
export const SUBSCRIBE_TO_OPERATOR_CHANGE = gql`
  subscription {
    subscribeToOperatorChange {
      id
      name
    }
  }
`;

const AuthorizedOperatorContext = createContext({
  operator: null,
  loading: true,
  refetch: () => {},
});

export const useAuthorizedOperator = () => useContext(AuthorizedOperatorContext);

export const AuthorizedOperatorProvider = ({ children }) => {
  // cache-and-network (not network-only) so the change OperatorSubscriber writes
  // into the cache re-emits here and updates the screen live.
  const { data, loading, refetch } = useQuery(AUTHORIZED_OPERATOR_QUERY, {
    fetchPolicy: "cache-and-network",
    client: httpClient,
  });

  const [operator, setOperator] = useState(null);

  useEffect(() => {
    if (data && data.getCurrentAutomationOperator) {
      setOperator(data.getCurrentAutomationOperator);
    } else {
      setOperator(null);
    }
  }, [data]);

  return (
    <AuthorizedOperatorContext.Provider value={{ operator, loading, refetch }}>
      {children}
    </AuthorizedOperatorContext.Provider>
  );
};
